import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useFormContext } from "react-hook-form";
import { notUndefinedNull } from "../helpers/shared"
import { addValue } from "../helpers/edit"
import { hiddenField, sOption } from "../constants/form"

export  const useAutocompleteDocuments = (field, uniqueName) => {
  const { defaultValuesTier, action } = useSelector(state => state.tier);
  const { areDocumentsFetched } = useSelector(state => state.base)
  const [areDocumentsProcessed, setAreDocumentsProcessed] = useState(false) 
  const storageDataKey = field?.storage_data_key ? JSON.parse(field.storage_data_key) : null
  const { setValue } = useFormContext();

  useEffect(() => {
    if (action === 'add') {
      // This effect runs once when the component mounts.
      // It initializes the state `areDocumentsProcessed` to `false`.
      setAreDocumentsProcessed(false)
    }
  }, [])

  useEffect(() => {
    let safetyDelay = 8000 // Delay required to ensure that the useEffects reseting the values have run already
    if (action === 'add'){
      // This effect runs whenever `areDocumentsFetched` or `areDocumentsProcessed` changes.
      // It sets a timeout of 8 seconds to ensure that the documents are fetched correctly.
      setTimeout(() => {
        // Add value to the field
        const value = addValue(field)
        // Check if the value is valid and not equal to hiddenField or sOption
        let valueExists = value && value !== hiddenField && value !== sOption && notUndefinedNull(value)
        
        // If documents are fetched, storageDataKey is 'documents', and value exists
        if ((areDocumentsFetched === true) && storageDataKey?.name === 'documents' && valueExists){
          // If the field datatype is not 'aux', set the value
          if (field?.datatype !== 'aux'){
            setValue(uniqueName, value)
          } 
            
          // Mark documents as processed
          setAreDocumentsProcessed(true)
        }
      }, safetyDelay)
    }
  }, [areDocumentsFetched, areDocumentsProcessed])

  return {}
}

